import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailHeaderComponent } from './detail-header.component';
import { DetailTabsComponent } from './detail-tabs.component';
import { DetailPanelComponent } from './detail-panel.component';
import { DetailPillComponent } from './detail-pill.component';

const COMPONENTS = [
  DetailHeaderComponent,
  DetailTabsComponent,
  DetailPanelComponent,
  DetailPillComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule],
  exports: COMPONENTS,
})
export class DetailKitModule {}
